import { IPlayerDataLabels, ITeamProfileStatistics } from '../../../../../packages/types';
import { getTeamStatisticRows } from '../../helpers/getTeamStatisticRows';

interface INormalizePlayerStatistics {
  statistics?: ITeamProfileStatistics;
  scheme?: string[];
  dataLabels?: IPlayerDataLabels;
}

export const normalizeTeamStatistics = ({ statistics, scheme, dataLabels }: INormalizePlayerStatistics) => {
  if (!statistics) {
    return { rows: [] };
  }

  const rows = getTeamStatisticRows(statistics, scheme, dataLabels);

  return { rows: rows };
};
